document.addEventListener("DOMContentLoaded", function () {
  const gallerySelector = ".mian-product-box product-media";

  function visibleItems(media) {
    return Array.from(media.querySelectorAll(".product__media-item:not(.is-filtered)"));
  }

  function altOf(el) {
    return `${el.getAttribute("data-media-alt") || ""} ${el.querySelector("img")?.getAttribute("alt") || ""}`;
  }

  function matchesVariantColor(el, variant) {
    const alt = altOf(el);
    const hash = alt.match(/#([A-Za-z0-9]+)_([^\s#]+)/);
    if (!hash) return true;
    const groupValue = hash[2].replace(/_/g, " ").trim().toLowerCase();
    const selected = String(variant.options?.[0] || variant.option1 || "")
      .replace(/_/g, " ")
      .trim()
      .toLowerCase();
    if (!selected) return true;
    return selected === groupValue;
  }

  function applyVariantMediaFilter(media, variant) {
    if (!variant) return;
    media.querySelectorAll(".product__media-item, .product__thumbnail-item, .dots-nav__item").forEach((el) => {
      el.classList.toggle("is-filtered", !matchesVariantColor(el, variant));
    });

    const items = visibleItems(media);
    items.forEach((item, index) => {
      item.classList.toggle("product__media-item--hero", index === 0);
      item.classList.toggle("is-selected", index === 0);
      item.classList.toggle("is-initial-selected", index === 0);
    });

    const selectedId = items[0]?.getAttribute("data-media-id");
    media.querySelectorAll(".product__thumbnail-item").forEach((thumb) => {
      if (thumb.classList.contains("is-filtered")) {
        thumb.removeAttribute("aria-current");
        return;
      }
      if (thumb.getAttribute("data-media-id") === selectedId) {
        thumb.setAttribute("aria-current", "true");
      } else {
        thumb.removeAttribute("aria-current");
      }
    });
  }

  async function getFlickity(media) {
    const carousel = media.querySelector("flickity-carousel");
    if (!carousel?.flickityInstance) return null;
    return Promise.race([
      carousel.flickityInstance,
      new Promise((resolve) => setTimeout(() => resolve(null), 800)),
    ]);
  }

  async function refreshCarousel(media) {
    const carousel = media.querySelector("flickity-carousel");
    const flickity = await getFlickity(media);
    if (flickity?.reloadCells) {
      flickity.reloadCells();
      flickity.resize();
      flickity.select(0, false, true);
      return;
    }
    if (carousel?.reload) {
      try {
        await carousel.reload();
      } catch (error) {}
    }
  }

  function syncArrows(media, flickity) {
    const prev = media.querySelector(".product__media-arrow--prev");
    const next = media.querySelector(".product__media-arrow--next");
    if (!prev || !next) return;
    const count = flickity?.slides?.length || visibleItems(media).length;
    const index = flickity?.selectedIndex || 0;
    prev.disabled = count <= 1 || index <= 0;
    next.disabled = count <= 1 || index >= count - 1;
  }

  function showFallbackIndex(media, next) {
    const items = visibleItems(media);
    if (!items.length) return;
    let index = items.findIndex((item) => item.classList.contains("is-selected"));
    if (index < 0) index = 0;
    index = next ? Math.min(index + 1, items.length - 1) : Math.max(index - 1, 0);
    items.forEach((item, itemIndex) => {
      item.classList.toggle("is-selected", itemIndex === index);
      item.classList.toggle("is-initial-selected", itemIndex === index);
    });
    const selectedId = items[index].getAttribute("data-media-id");
    media.querySelectorAll(".product__thumbnail-item:not(.is-filtered)").forEach((thumb) => {
      if (thumb.getAttribute("data-media-id") === selectedId) {
        thumb.setAttribute("aria-current", "true");
      } else {
        thumb.removeAttribute("aria-current");
      }
    });
    syncArrows(media, { selectedIndex: index, slides: items });
  }

  function bindGallery(media) {
    if (media.dataset.galleryBound === "true") return;
    media.dataset.galleryBound = "true";

    media.addEventListener(
      "click",
      async (event) => {
        const prev = event.target.closest(".product__media-arrow--prev");
        const next = event.target.closest(".product__media-arrow--next");
        if (!prev && !next) return;
        if (prev?.disabled || next?.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        const flickity = await getFlickity(media);
        if (flickity?.next) {
          const before = flickity.selectedIndex;
          if (next) flickity.next();
          else flickity.previous();
          if (flickity.selectedIndex === before) {
            flickity.reloadCells();
            flickity.resize();
            if (next) flickity.next();
            else flickity.previous();
          }
          if (flickity.selectedIndex === before) {
            showFallbackIndex(media, Boolean(next));
          } else {
            syncArrows(media, flickity);
          }
          return;
        }
        showFallbackIndex(media, Boolean(next));
      },
      true,
    );
  }

  document.addEventListener("flickity:ready", async (event) => {
    const media = event.target.closest?.(gallerySelector);
    if (!media || event.target !== media.querySelector("flickity-carousel")) return;
    const flickity = await getFlickity(media);
    if (flickity?.reloadCells) {
      flickity.reloadCells();
      flickity.resize();
    }
    syncArrows(media, flickity);
  });

  document.addEventListener("flickity:slide-changed", async (event) => {
    const media = event.target.closest?.(gallerySelector);
    if (!media) return;
    syncArrows(media, await getFlickity(media));
  });

  document.addEventListener("variant:change", async (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;
    const formId = event.target?.id;
    const media =
      (formId && document.querySelector(`${gallerySelector}[form-id="${formId}"]`)) ||
      document.querySelector(gallerySelector);
    if (!media) return;
    applyVariantMediaFilter(media, variant);
    await refreshCarousel(media);
    bindGallery(media);
  });

  function initExisting() {
    document.querySelectorAll(gallerySelector).forEach((media) => {
      bindGallery(media);
      visibleItems(media).forEach((item, index) => {
        item.classList.toggle("product__media-item--hero", index === 0);
      });
    });
  }

  initExisting();
  document.addEventListener("product:rerender", () => {
    document.querySelectorAll(gallerySelector).forEach((media) => {
      media.dataset.galleryBound = "";
      bindGallery(media);
    });
  });



  // Key Features弹窗
  function lockScroll() {
    document.body.style.overflow = "hidden";
  }

  function unlockScroll() {
    document.body.style.overflow = "";
  }

  function openKeyFeatures(box) {
    var layout = box.nextElementSibling;
    if (layout && layout.classList.contains("key-features-window-layout")) {
      layout.classList.add("active");
      lockScroll();
    }
  }

  function closeKeyFeatures(layout) {
    if (layout && layout.classList.contains("key-features-window-layout")) {
      layout.classList.remove("active");
      unlockScroll();
    }
  }

  document.addEventListener("click", function (e) {
    var box = e.target.closest(".key-features-box");
    if (box) {
      openKeyFeatures(box);
      return;
    }

    var mask = e.target.closest(".key-features-mask-layer");
    if (mask) {
      closeKeyFeatures(mask.closest(".key-features-window-layout"));
      return;
    }

    var closeBtn = e.target.closest(".key-features-window-close");
    if (closeBtn) {
      closeKeyFeatures(closeBtn.closest(".key-features-window-layout"));
      return;
    }
  });

  
  // Bulk Discount弹窗
  function openBulkDiscount() {
    var wrapper = document.querySelector(".bulk-discount-window-wrapper");
    if (wrapper) {
      wrapper.classList.add("active");
      lockScroll();
    }
  }

  function closeBulkDiscount() {
    var wrapper = document.querySelector(".bulk-discount-window-wrapper");
    if (wrapper) {
      wrapper.classList.remove("active");
      unlockScroll();
    }
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest(".bulk-discount-help")) {
      openBulkDiscount();
      return;
    }

    if (e.target.closest(".bulk-discount-window-close") || e.target.closest(".bulk-discount-window-mask")) {
      closeBulkDiscount();
      return;
    }
  });



  // Services and Benefits
  document.addEventListener("click", function (e) {
    var item = e.target.closest(".benefits-item");
    if (!item) return;

    item.classList.toggle("active");
  });



  // 底部悬浮购物栏 buy now 按钮获取加购数量
  var buyNowBtn = document.querySelector(".sticky-form-buy-now");
  var customBuyNow = document.querySelector(".custom_buy_now");

  if (!buyNowBtn && !customBuyNow) return;

  var quantityInput = document.querySelector(
    '.product__info input[name="quantity"]',
  );
  if (!quantityInput) return;

  function updateQuantity() {
    // 存在才设置属性，避免报错
    if (buyNowBtn) buyNowBtn.setAttribute("data-quantity", quantityInput.value);
    if (customBuyNow)
      customBuyNow.setAttribute("data-quantity", quantityInput.value);
  }

  quantityInput.addEventListener("input", updateQuantity);
  quantityInput.addEventListener("change", updateQuantity);
  document.addEventListener("click", function (e) {
    if (e.target.closest(".quantity-selector__button")) {
      setTimeout(updateQuantity, 50);
    }
  });
  updateQuantity();





    // Bulk Discount 表单 AJAX 提交（不刷新页面）
  var bulkForm = document.querySelector(".bulk-form-box form");
  if (bulkForm) {
    var bulkBtn = bulkForm.querySelector(".bulk-form-btn");
    if (bulkBtn) bulkBtn.setAttribute("type", "button");

    bulkBtn.addEventListener("click", function () {
      if (!bulkForm.checkValidity()) {
        bulkForm.reportValidity();
        return;
      }

      var btn = this;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Submitting...";

      fetch(bulkForm.action, {
        method: "POST",
        body: new FormData(bulkForm),
      })
        .then(function () {
          bulkForm.innerHTML =
            '<p class="bulk-form-message">Submit success! We will contact you soon.</p>';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          alert("Network error, please try again later.");
        });
    });
  }

});
